export const subcategoryTypesEnum = Object.freeze({
    GRID_PAGE: 'gridPage',
    CATEGORY: 'category',
});
